import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status",
  "use": "status-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"status\"><g fill-rule=\"nonzero\"><path d=\"M1 5h2a1 1 0 011 1v10H0V6a1 1 0 011-1zM7 0h2a1 1 0 011 1v15H6V1a1 1 0 011-1zM13 11h2a1 1 0 011 1v4h-4v-4a1 1 0 011-1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id